import { render, staticRenderFns } from "./editPro.vue?vue&type=template&id=83cc90fc&"
import script from "./editPro.vue?vue&type=script&lang=js&"
export * from "./editPro.vue?vue&type=script&lang=js&"
import style0 from "./editPro.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports